jQuery(document).ready(function($) {

  // Step 1
  function dentalStepReset() {
    $('#doggroup-container').css({
      'top': 'px'
    });

    $('#doggroup path').each(function() {
      // $(this).removeClass();
      // $(this).addClass('step-reset');
      $(this).attr('class', 'step-reset');
    });

    $('#doggroup-container [data-step]').each(function() {
      $(this).removeClass('fadein');
    });

    $('[data-step="1"]').addClass('fadein');

    getStep(1);
  }

  function getStep(step) {
    $('#doggroup-container [data-step]').each(function() {
      $(this).removeClass('fadein');
    });

    $('[data-step="'+step+'"]').addClass('fadein');

    $('.right-progress li').each(function() {
      $(this).removeClass('active');
    });
    $('.right-progress li:nth-child('+step+')').addClass('active');

    switch(step) {
      case 1:
        $('#dental-percentage').fadeOut();
        // $('#dental-percentage-number').text('0');
        if($('#dental-percentage-number').text() !== '0') {
          animateValue('dental-percentage-number', 80, 0, 1000);
        }
        break;
      case 2:
        $('#dental-percentage').fadeIn();
        $('#dental-percentage').addClass('light-green');
        $('#dental-percentage').removeClass('orange');
        $('#dental-percentage').removeClass('dark-green');
        // $('#dental-percentage .number').text('80');
        if($('#dental-percentage-number').text() !== '80') {
          animateValue('dental-percentage-number', 0, 80, 1000);
        }
        break;
      case 3:
        // $('#dental-percentage .number').text('96');
        $('#dental-percentage').removeClass('light-green');
        $('#dental-percentage').addClass('orange');
        $('#dental-percentage').removeClass('dark-green');
        if($('#dental-percentage-number').text() !== '96') {
          animateValue('dental-percentage-number', 80, 96, 1000);
        }
        break;
      case 4:
        // $('#dental-percentage .number').text('14');
        $('#dental-percentage').removeClass('light-green');
        $('#dental-percentage').removeClass('orange');
        $('#dental-percentage').addClass('dark-green');
        if($('#dental-percentage-number').text() !== '14') {
          animateValue('dental-percentage-number', 96, 14, 1000);
        }
        break;
      case 5:
        // $('#dental-percentage .number').text('2');
        $('#dental-percentage').removeClass('light-green');
        $('#dental-percentage').removeClass('orange');
        $('#dental-percentage').addClass('dark-green');
        if($('#dental-percentage-number').text() !== '2') {
          animateValue('dental-percentage-number', 14, 2, 1000);
        }
        break;
    }

    // $('#doggroup-container .footer-progress span').css({
    //   'width': ((20) * step) + '%'
    // });
  }

  // Step 2
  function dentalStep2() {
    var step2IDgray = [150, 147, 149, 148, 143, 144, 145, 146, 122, 124, 127, 132, 133, 223, 134, 138, 139, 140, 155, 153 ];

    $('#doggroup-container').css({
      'top': $('header.header').outerHeight()+'px'
    });

    $('#doggroup path').each(function() {
      // $(this).removeClass();
      var pathID = parseInt($(this).attr('id').replace('Path_', ''));
      var $thisElem = $(this);

      if(!step2IDgray.includes(pathID)) {
        // $thisElem.removeClass();
        $thisElem.attr('class', 'step2-green');
      } else {
        // $thisElem.removeClass();
        // $thisElem.addClass('step-reset');
        $thisElem.attr('class', 'step-reset');
      }
    });

    getStep(2);
  }


  // Step 3
  function dentalStep3() {
    var step3IDgray = [218, 148, 220, 153];

    $('#doggroup path').each(function() {
      // $(this).removeClass();
      var pathID = parseInt($(this).attr('id').replace('Path_', ''));
      var $thisElem = $(this);

      if(!step3IDgray.includes(pathID)) {
        // $thisElem.removeClass();
        $thisElem.attr('class', 'step3-orange');
      } else {
        // $thisElem.removeClass();
        // $thisElem.addClass('step-reset');
        $thisElem.attr('class', 'step-reset');
      }
    });

    getStep(3);
  }

  // Step 4
  function dentalStep4() {
    var step4IDgreen = [215, 183, 204, 199, 198, 197, 174, 172, 209, 152, 144, 125, 132, 135, 139];

    $('#doggroup path').each(function() {
      // $(this).removeClass();
      var pathID = parseInt($(this).attr('id').replace('Path_', ''));
      var $thisElem = $(this);

      if(step4IDgreen.includes(pathID)) {
        // $thisElem.removeClass();
        $thisElem.attr('class', 'step4-green');
      } else {
        // $thisElem.removeClass();
        // $thisElem.addClass('step-reset');
        $thisElem.attr('class', 'step-reset');
      }

    });

    getStep(4);
  }

  // Step 5
  function dentalStep5() {
    var step5IDgreen = [172, 135];

    $('#doggroup path').each(function() {
      // $(this).removeClass();
      var pathID = parseInt($(this).attr('id').replace('Path_', ''));
      var $thisElem = $(this);

      if(step5IDgreen.includes(pathID)) {
        // $thisElem.removeClass();
        $thisElem.attr('class', 'step5-green');
      } else {
        // $thisElem.removeClass();
        // $thisElem.addClass('step-reset');
        $thisElem.attr('class', 'step-reset');
      }
    });

    getStep(5);
  }

  var controller = new ScrollMagic.Controller();
  var scenesArray = [];
  var scrollDuration = 200;


  if($("#doggroup-container").length) {
    // Scene Wrapping Pin
    scenesArray.push(new ScrollMagic.Scene({
      triggerElement: "#doggroup-container",
      triggerHook: "onLeave",
      duration: (scrollDuration * 4) + 80,
      offset: -80
    })
    .setTween($('#doggroup-container .footer-progress .bar'), 1, {'width': '100%', ease:Linear.easeNone})
    .setPin('#doggroup-container')
  	// .addIndicators()
    .on("start", function(e) {
  		dentalStepReset();
  	})
    .on("enter", function(e) {
      $('#doggroup-container .footer-progress').removeClass('hide');
    })
    .on("leave", function(e) {
      $('#doggroup-container .footer-progress').addClass('hide');
    })
  	.addTo(controller)
    );

    // Step 2
    scenesArray.push(new ScrollMagic.Scene({
      triggerElement: "#doggroup-container",
      triggerHook: "onLeave",
      duration: scrollDuration,
      // offset: -100
    })
    // .setPin('#doggroup-container')
  	// .addIndicators()
    .on("enter", function(e) {
  		dentalStep2();
  	})
    // .on("leave", function(e) {
    //   dentalStep1();
    // })
  	.addTo(controller)
    );

    scenesArray.push(new ScrollMagic.Scene({
      triggerElement: "#doggroup-container",
      triggerHook: "onLeave",
      duration: scrollDuration,
      offset: scrollDuration
    })
    // .setPin('#doggroup-container')
  	// .addIndicators()
    .on("enter", function(e) {
  		dentalStep3();
  	})
  	.addTo(controller)
    );

    scenesArray.push(new ScrollMagic.Scene({
      triggerElement: "#doggroup-container",
      triggerHook: "onLeave",
      duration: scrollDuration,
      offset: (scrollDuration * 2)
    })
    // .setPin('#doggroup-container')
  	// .addIndicators()
    .on("enter", function(e) {
  		dentalStep4();
  	})
  	.addTo(controller)
    );

    scenesArray.push(new ScrollMagic.Scene({
      triggerElement: "#doggroup-container",
      triggerHook: "onLeave",
      duration: scrollDuration,
      offset: (scrollDuration * 3)
    })
    // .setPin('#doggroup-container')
  	// .addIndicators()
    .on("enter", function(e) {
      dentalStep5();
  	})
  	.addTo(controller)
    );
  }

  $('.right-progress button').click(function() {
    var scrollToPoint = scrollDuration * ($(this).attr('data-jump-to') - 1);
    $('html, body').animate({
      scrollTop: scrollToPoint
    }, 1000);
  });

  function getNavHeight() {
    // console.log($('header.header').outerHeight())
    return $('header.header').outerHeight();
  }

});
